export default __webpack_public_path__ + "static/media/import.f38b0c50.svg";